<template>
    <div>
        <app-data-table
            ref="archived-tasks-table"
            :fields="fields"
            with="venue:venues.id,venues.name;user:users.id,users.name;files;createdBy:users.id,users.name"
            resource="administrative-tasks"
            :hard-filters="hardFilters"
            :mutator="rowStatus"
        >
            <template #cell(actions)="{ item, toggleDetails }">
                <b-btn variant="primary" :id="`btn-options-${item.id}`" size="sm"> <i class="fas fa-cogs"></i> Opciones </b-btn>
                    <b-popover :target="`btn-options-${item.id}`" triggers="click blur" placement="lefttop">
                    <div>
                        <b-row class="mb-2">
                            <b-col>
                                <b-btn size="sm" variant="primary" @click="toggleDetails" title="Ver Detalles" block>
                                    <i class="fa fa-eye"></i> Ver detalles
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </b-popover>
            </template>
            <template #cell(due_date)="{ item }">  
                {{ item.due_date ? moment(item.due_date).format('DD/MM/YYYY HH:mm:ss') : 'Sin fecha de vencimiento' }}
            </template>
            <template #cell(created_at)="{ item }">
                {{ item.created_at | date }}
            </template>
            <template #cell(status)="{ item }">
                <span :class="['status-btn', getStatusClass(item.status)]">{{ item.status }}</span>
            </template>
            <template #cell(start_date)="{ item }">
                {{ item.start_date ? moment(item.start_date).format('DD/MM/YYYY HH:mm:ss') : 'Sin iniciar' }}
            </template>
            <template #cell(ticket)="{ item }">
                {{ item.petition_code ?? 'N/A' }}
            </template>
            <template #cell(finish_date)="{ item }">
                {{ item.finish_date ? moment(item.finish_date).format('DD/MM/YYYY HH:mm:ss') : 'Sin finalizar' }}
            </template>
            <template #cell(archived_date)="{ item }">
                {{ item.archived_at ? moment(item.archived_at).format('DD/MM/YYYY HH:mm:ss') : '' }}
            </template>
            <template #row-details="{ item }">
                <div class="task-description">
                    <div v-html="item.description"></div>
                    <ul>
                        <li v-for="file in item.files" :key="file.id">
                            <i class="fas fa-2x" :style="{ color: getDocumentColor(file.ext) }" :class="getIconClass(file.ext)"></i>
                            <a title="Descargar" :href="`web/v1/downloads/task-files/${file.id}`" target="_blank">{{ file.name }}</a>
                        </li>
                    </ul>
                </div>
            </template>
        </app-data-table>
        
    </div>
    
</template>
<script>
import appResolutionTaskForm from './ResolutionTaskForm'
export default {
    components: {
        appResolutionTaskForm,
    },
    props: {
        filters: {
            type: Object,
        },
    },
    data: () => ({
        fields,
        selectedTask: '',
        isEditing: false,
        busy: false,
    }),
    computed: {
        hardFilters() {
            return {
                ...this.filters,
                client_id: this.currentClient.id,
                filter_private_tasks: true,
                archived_tasks: true,
                sortBy: 'created_at',
                sortDir: 'desc',
            }
        },
    },
    methods: {
        refreshTable() {
            this.$refs['archived-tasks-table'].refresh()
        },
        rowStatus(item) {
            let status;
            const today = moment().startOf('day'); // Obtiene la fecha actual sin la hora

            // Función auxiliar para comparar fechas sin tener en cuenta la hora
            const isBefore = (date1, date2) => {
                return moment(date1).startOf('day').isBefore(moment(date2).startOf('day'));
            };

            if (item.start_date && !item.finish_date) {
                if (item.due_date && isBefore(item.due_date, today)) {
                    status = 'Vencida';
                } else {
                    status = 'En progreso';
                }
            } else if (item.start_date && item.finish_date) {
                status = 'Finalizada';
            } else if (item.due_date && isBefore(item.due_date, today)) {
                status = 'Vencida';
            } else {
                status = 'Pendiente';
            }

            return { ...item, status };
        },
        getStatusClass(status) {
            switch (status) {
            case 'En progreso':
                return 'btn-warning';
            case 'Finalizada':
                return 'btn-success';
            case 'Pendiente':
                return 'btn-secondary';
            case 'Vencida':
                return 'btn-danger';
            default:
                return 'btn-light';
        }
        },
        getIconClass(ext) {
            return fileIcons[ext] || 'fa-file'
        },
        getDocumentColor(ext) {
            return fileColors[ext] || '#153F7B'
        },
    },
}

const fields = [
    {
        key: 'name',
        label: 'Título',
    },
    {
        key: 'ticket',
        label: 'Ticket PQR',
    },
    {
        key: 'user.name',
        label: 'Responsable',
    },
    {
        key: 'created_by.name',
        label: 'Creada por',
    },
    {
        key: 'venue.name',
        label: 'Sede',
    },
    {
        key: 'status',
        label: 'Estado',
    },
    {
        key: 'start_date',
        label: 'Fecha de inicio',
    },
    {
        key: 'due_date',
        label: 'Fecha de vencimiento',
    },
    {
        key: 'created_at',
        label: 'Fecha de creación',
    },
    {
        key: 'archived_date',
        label: 'Fecha de archivado',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
const fileIcons = {
    xlsx: 'fa-file-excel',
    xls: 'fa-file-excel',
    csv: 'fa-file-excel',
    docx: 'fa-file-word',
    doc: 'fa-file-word',
    txt: 'fa-file-word',
    pdf: 'fa-file-pdf',
    png: 'fa-file-image',
    jpg: 'fa-file-image',
    jpeg: 'fa-file-image',
    gif: 'fa-file-image',
}
const fileColors = {
    xlsx: '#107C41',
    xls: '#107C41',
    csv: '#107C41',
    docx: '#103F91',
    doc: '#103F91',
    txt: '#103F91',
    pdf: '#B30B00',
    png: '#3CA8E9',
    jpg: '#3CA8E9',
    jpeg: '#3CA8E9',
    gif: '#3CA8E9',
}
</script>
<style scoped>
.task-description {
    background-color: white;
    color: rgb(42, 42, 42);
    padding: 10px 20px;
    text-align: justify;
    border-radius: 4px;
}
.input-help-text {
    margin-top: -0.5rem;
    display: block;
}
.status-btn {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: default;
}

.btn-warning {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn-light {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}
.btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}
</style>

